import GeneralModal from "../../GeneralModal";
import MSGameEngine from "./Engine";

function MinesweeperApp() {

    return (
        <GeneralModal id='minesweeper'>
            <MSGameEngine />
        </GeneralModal>
    )
}

export default MinesweeperApp;
